import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { H1 } from 'scy/text';
import styles from './headerImage.mod.scss';

function imageUrl({ title, url_name }) {
  if (!title && !url_name) return null;

  const BASE_URL = 'https://saucey-media.s3.amazonaws.com/web/category-images';

  const urlName = (title || url_name)
    .toLowerCase()
    .replace(/[^\w]/g, '')
    .replace(/\s/g, '-');

  return `${BASE_URL}/${urlName}-header-image.jpg`;
}

export default function CategoryHeaderImage({
  category = {},
  loading,
  className
}) {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const { title, name, url_name } = category;
  const url = loading ? null : imageUrl({ title, url_name });

  useEffect(() => {
    if (!url) return;
    setImageLoading(true);
    const image = new Image();
    image.src = url;
    image.onload = () => {
      setImageLoading(false);
      setImageError(false);
    };
    image.onerror = () => {
      setImageLoading(false);
      setImageError(true);
    };
  }, [url]);

  return (
    <div
      className={classnames(styles.container, className, {
        [styles.loading]: loading || imageLoading
      })}
      style={{ backgroundImage: imageError || !url ? null : `url(${url})` }}
    >
      <H1
        className={classnames(styles.title, { [styles.noImage]: imageError })}
      >
        {loading ? null : title || name}
      </H1>
    </div>
  );
}
